import { DEFAULT_OPTION } from '@/fsd/feature/cashbox/paginate-cashbox-item/model/consts/const';
import { PageSizeSelect } from '@/fsd/shared/ui/PageSizeSelect';
import {
  CustomPagination,
  CustomPaginationItem,
} from '@/fsd/shared/ui/pagination';
import RemainsStore from '../../model/store/RemainsStore';
import styles from './RemainsPagination.module.scss';

interface IProps {
  totalPages: number;
}

export const RemainsPagination = ({ totalPages }: IProps) => {
  const { page, setPage, pageSize, setPageSize } = RemainsStore;

  return (
    <div className={styles.paginationWrapper}>
      <CustomPagination
        count={totalPages}
        page={page}
        variant="outlined"
        shape="rounded"
        onChange={(e, page) => setPage(page)}
        renderItem={(item) => <CustomPaginationItem {...item} />}
      />
      <div className={styles.wrapper}>
        <p className={styles.title}>Строк на странице</p>
        <PageSizeSelect
          defaultOption={DEFAULT_OPTION}
          value={String(pageSize)}
          fieldName={'value'}
          onOptionChange={(pageSize) => setPageSize(pageSize.value)}
          openDirection="top"
        />
      </div>
    </div>
  );
};
